
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Infrastructure.css";

import infrastructureMain from "../assets/Facilities/1.jpg.jpeg";
import infrastructureMain2 from "../assets/Facilities/2.jpg.jpeg";
import infrastructureMain3 from "../assets/Facilities/3.jpg.jpeg";
import infrastructureMain4 from "../assets/Facilities/4.jpg.jpeg";
import infrastructureMain5 from "../assets/Facilities/5.jpg.jpeg";
import infrastructureMain6 from "../assets/Facilities/6.jpg.jpeg";
import image3 from"../assets/images/Encouraging All-Round Development .jpeg";
import image1 from "../assets/images/A Space That Inspires Learning & Growth.jpg.jpeg"
const facilities = [
  {
    image: infrastructureMain,
    icon: "bi-easel-fill",
    number: "01",
    title: "Well-Ventilated Classrooms",
    description:
      "The school is equipped with well-ventilated classrooms that facilitate effective teaching and learning."
  },
  {
    image: infrastructureMain2,
    icon: "bi-flask-fill",
    number: "02",
    title: "Laboratories",
    description:
      "Essential laboratory facilities encourage practical knowledge, exploration and creativity among students."
  },
  {
    image: infrastructureMain3,
    icon: "bi-book-half",
    number: "03",
    title: "Library",
    description:
      "The library supports reading habits, independent learning and the development of knowledge."
  },
  {
    image: infrastructureMain4,
    icon: "bi-pc-display",
    number: "04",
    title: "Computer-Based Learning",
    description:
      "Computer-based learning resources help students develop technological skills and digital awareness."
  },
  {
    image: infrastructureMain5,
    icon: "bi-trophy-fill",
    number: "05",
    title: "Sports & Physical Activities",
    description:
      "Sports and physical activities promote fitness, teamwork, discipline and a healthy lifestyle."
  },
  {
    image: infrastructureMain6,
    icon: "bi-people-fill",
    number: "06",
    title: "Cultural & Co-curricular Activities",
    description:
      "Dedicated spaces and opportunities encourage students to explore talents and develop confidence and leadership qualities."
  }
];

const Infrastructure = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".infrastructure-page .animate-on-scroll"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animation");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="infrastructure-page">

      {/* HERO SECTION */}
      <section className="infrastructure-hero">
        <div className="container">
          <div className="infrastructure-hero-content">

            <h1>
              School <span>Infrastructure</span>
            </h1>

            <p>
              Creating an inspiring environment for learning,
              discovery and all-round development.
            </p>

            <div className="infrastructure-breadcrumb">
              <Link to="/">Home</Link>
              <i className="bi bi-chevron-right"></i>
              <span>Infrastructure</span>
            </div>

          </div>
        </div>
      </section>

      {/* INTRODUCTION */}
      <section className="infrastructure-intro section-space">
        <div className="container">
          <div className="row align-items-center g-5">

            <div className="col-lg-6">
              <div className="infrastructure-main-image animate-on-scroll animate-left">

                <img
                  src={image1}
                  alt="Air Force School infrastructure"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="infrastructure-intro-content animate-on-scroll animate-right">

                <span className="infrastructure-label">
                  <i className="bi bi-stars"></i>
                  Our Infrastructure
                </span>

                <h2>
                  A Space That Inspires
                  <span> Learning & Growth</span>
                </h2>

                <p>
                  Air Force School, Vayu Sena Nagar, Nagpur, provides a
                  conducive and student-friendly environment that supports
                  academic excellence and the holistic development of
                  learners. The school is equipped with well-ventilated
                  classrooms that facilitate effective teaching and learning.
                </p>

                <p>
                  It provides essential academic facilities, including
                  laboratories, a library, and computer-based learning
                  resources, to encourage practical knowledge, creativity,
                  and technological skills.
                </p>

                <div className="infrastructure-check">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>
                    A supportive atmosphere for every learner.
                  </span>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FACILITIES */}
      <section className="infrastructure-facilities section-space">
        <div className="container">

          <div className="infrastructure-section-heading text-center animate-on-scroll">

            <span className="infrastructure-label">
              <i className="bi bi-grid-fill"></i>
              Campus Facilities
            </span>

            <h2>
              Facilities for <span>Every Learner</span>
            </h2>

            <p>
              An environment that encourages practical learning,
              physical fitness, creativity and student participation.
            </p>

          </div>

          <div className="row g-4 mt-3">

            {facilities.map((facility) => (
              <div className="col-md-6 col-lg-4" key={facility.number}>
                <div className="infrastructure-facility-card animate-on-scroll">

                  <div className="facility-image">
                    <img
                      src={facility.image}
                      alt={facility.title}
                      loading="lazy"
                    />

                  </div>

                  <div className="facility-content">

                    <div className="facility-icon">
                      <i className={`bi ${facility.icon}`}></i>
                    </div>

                    <h3>{facility.title}</h3>

                    <p>{facility.description}</p>

                  </div>

                </div>
              </div>
            ))}

          </div>

        </div>
      </section>

      {/* STUDENT DEVELOPMENT */}
      <section className="infrastructure-development section-space">
        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-5">
              <div className="development-content animate-on-scroll animate-left">

                <span className="infrastructure-label">
                  <i className="bi bi-lightbulb-fill"></i>
                  Beyond Classrooms
                </span>

                <h2>
                  Encouraging
                  <span> All-Round Development</span>
                </h2>

                <p>
                  The school also provides facilities for sports and
                  physical activities to promote fitness, teamwork,
                  discipline, and a healthy lifestyle. Dedicated spaces
                  for cultural programmes, assemblies, and co-curricular
                  activities encourage students to explore their talents
                  and develop confidence and leadership qualities.
                </p>

                <p>
                  Emphasis is placed on maintaining cleanliness,
                  discipline, and a safe learning environment for
                  students and staff.
                </p>

              </div>
            </div>

            <div className="col-lg-7">
              <div className="development-image animate-on-scroll animate-right">
                <img
                    src={image3}
                  alt="Student activities at Air Force School"
                  loading="lazy"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

    </main>
  );
};

export default Infrastructure;
